/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import localOriginCharges from "../../../Services/localOriginCharges";
import locationServices from "../../../Services/locationServices";
import Loader from "../../../Components/Loader";

export const EditAirOriginCharge = () => {
  const [countryList, setCountryList] = useState([]);
  const [originCountryValue, setCountryValue] = useState("");
  const [loader, setLoader] = useState(true);

  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      country: "",
      awb_fee: "",
      // handling_out: '',
      handling_in: "",
      airline_handling: "",
      customs_docs: "",
      min_transport_s2d_to_apt: "",
      transport_s2d_to_apt: "",
      // min_customs_docs: '',
      // min_handling_out: '',
      min_handling_in: "",
      min_airline_handling: "",
    },
    validationSchema: Yup.object({
      country: Yup.string().required("Required"),
      handling_in: Yup.string().required("Required"),
      // handling_out: Yup.string().required('Required'),
      airline_handling: Yup.string().required("Required"),
      customs_docs: Yup.string().required("Required"),
      transport_s2d_to_apt: Yup.string().required("Required"),
      awb_fee: Yup.string().required("Required"),
      min_handling_in: Yup.string().required("Required"),
      // min_handling_out: Yup.string().required('Required'),
      min_airline_handling: Yup.string().required("Required"),
      // min_customs_docs: Yup.string().required('Required'),
      min_transport_s2d_to_apt: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setLoader(true);
      let postData = {
        ...values,
      };
      localOriginCharges.updateLocalOriginChargeAir(postData).then((res) => {
        if (res.status) {
          setLoader(false);
          history.push("/air-origin-charge-list");
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  useEffect(() => {
    getCountryList();
    getDetails();
    // eslint-disable-next-line
  }, []);

  const getCountryList = () => {
    let param = {
      limit: 250,
      page: 1,
    };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        // eslint-disable-next-line
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name, data: list });
        });
        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };

  const getDetails = () => {
    let details = history.location.state;
    setCountryValue({
      value: details.country._id,
      label: details.country.country_name,
    });
    formik.setValues({
      country: details.country._id,
      awb_fee: details.awb_fee,
      handling_in: details.handling_in,
      handling_out: details.handling_out,
      airline_handling: details.airline_handling,
      customs_docs: details.customs_docs,
      transport_s2d_to_apt: details.transport_s2d_to_apt,
      min_handling_in: details.min_handling_in,
      min_handling_out: details.min_handling_out,
      min_airline_handling: details.min_airline_handling,
      min_customs_docs: details.min_customs_docs,
      min_transport_s2d_to_apt: details.min_transport_s2d_to_apt,
      _id: details._id,
    });
    setLoader(false);
  };

  const onSelectCountry = (e) => {
    setCountryValue(e);
    formik.setValues({ ...formik.values, country: e.value });
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label"> Country </label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.country
                            ? !formik.errors.country
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      // isMulti
                      value={originCountryValue}
                      onChange={(e) => onSelectCountry(e)}
                      options={countryList}
                      isDisabled
                    />
                    {formik.touched.country && formik.errors.country ? (
                      <div className="text-danger">{formik.errors.country}</div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">AWB Fee (Aed)</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.awb_fee
                          ? !formik.errors.awb_fee
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("awb_fee")}
                      placeholder="Enter AWB Fee"
                    />
                    {formik.touched.awb_fee && formik.errors.awb_fee ? (
                      <div className="text-danger">{formik.errors.awb_fee}</div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Airline Handling /Kg</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.airline_handling
                          ? !formik.errors.airline_handling
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("airline_handling")}
                      placeholder="airline handling"
                    />
                    {formik.touched.airline_handling &&
                    formik.errors.airline_handling ? (
                      <div className="text-danger">
                        {formik.errors.airline_handling}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">
                      Minimum Airline Handling (Aed)
                    </label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.min_airline_handling
                          ? !formik.errors.min_airline_handling
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("min_airline_handling")}
                      placeholder="Enter AWB Fee"
                    />
                    {formik.touched.min_airline_handling &&
                    formik.errors.min_airline_handling ? (
                      <div className="text-danger">
                        {formik.errors.min_airline_handling}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Customs Docs (Aed)</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.customs_docs
                          ? !formik.errors.customs_docs
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("customs_docs")}
                      placeholder="customs docs"
                    />
                    {formik.touched.customs_docs &&
                    formik.errors.customs_docs ? (
                      <div className="text-danger">
                        {formik.errors.customs_docs}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">
                      Transport ( S2D to Apt) in Aed
                    </label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.transport_s2d_to_apt
                          ? !formik.errors.transport_s2d_to_apt
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("transport_s2d_to_apt")}
                      placeholder="transport ( S2D to Apt)"
                    />
                    {formik.touched.transport_s2d_to_apt &&
                    formik.errors.transport_s2d_to_apt ? (
                      <div className="text-danger">
                        {formik.errors.transport_s2d_to_apt}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Handling In/Out per cbm</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.handling_in
                          ? !formik.errors.handling_in
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("handling_in")}
                      placeholder="handling In/Out"
                    />
                    {formik.touched.handling_in && formik.errors.handling_in ? (
                      <div className="text-danger">
                        {formik.errors.handling_in}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">
                      {" "}
                      Minimum Handling In/Out (Aed)
                    </label>
                  </div>
                  <div className="col-9">
                    <input
                      type="number"
                      min="0"
                      className={
                        "form-control" +
                        (formik.touched.min_handling_in
                          ? !formik.errors.min_handling_in
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("min_handling_in")}
                      placeholder="min handling In/Out"
                    />
                    {formik.touched.min_handling_in &&
                    formik.errors.min_handling_in ? (
                      <div className="text-danger">
                        {formik.errors.min_handling_in}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};
